<template>
  <div class="tab-panel-body">
    <!-- Header -->
    <div class="config-section-header">
      <div class="config-section-header__left">
        <v-icon small class="mr-2" color="text_secondary">mdi-television</v-icon>
        <span class="config-section-label">Configuração da tarja</span>
      </div>
    </div>

    <!-- Settings -->
    <div class="sc-settings-list sc-settings-list--with-footer-gap">
      <!-- Position -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-arrow-left-right</v-icon>
          <span class="sc-settings-list__name">Posição do card na tarja</span>
        </div>
        <v-select
          outlined
          dense
          solo
          flat
          hide-details
          v-model="selectedTarjaPosition"
          :items="tarjaPositionOptions"
          placeholder="Selecione"
          class="tarja-select"
        />
      </div>

      <!-- Color config -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-palette-swatch</v-icon>
          <span class="sc-settings-list__name">Configuração de cores</span>
        </div>
        <v-select
          outlined
          dense
          solo
          flat
          hide-details
          v-model="selectedProducaoConfigCoresTarja"
          :items="producaoConfigCoresTarja"
          item-text="dsc_nome_config"
          item-value="id"
          return-object
          placeholder="Selecione"
          no-data-text="Nenhuma configuração encontrada"
          class="tarja-select"
        />
      </div>

      <!-- Phone -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-phone</v-icon>
          <span class="sc-settings-list__name">Número de telefone da produção</span>
        </div>
        <v-text-field
          solo
          flat
          dense
          hide-details
          v-model="dsc_telefone_producao"
          placeholder="(00) 00000-0000"
          class="tarja-input"
        />
      </div>

      <!-- Toggles -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-gesture-tap</v-icon>
          <div class="sc-settings-list__text">
            <span class="sc-settings-list__name">Botão de confirmação</span>
            <span class="sc-settings-list__desc">Exibir confirmação ao clicar em exibir/remover tarja</span>
          </div>
        </div>
        <v-switch
          v-model="flg_botao_confirmar_exibicao_tarja"
          color="primary"
          hide-details
          dense
          class="mt-0 pt-0"
        />
      </div>

      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-eye-off</v-icon>
          <div class="sc-settings-list__text">
            <span class="sc-settings-list__name">Ocultar informações do colaborador</span>
            <span class="sc-settings-list__desc">Esconder nome e foto do colaborador na tarja</span>
          </div>
        </div>
        <v-switch
          v-model="flg_ocultar_header_card_tarja"
          color="primary"
          hide-details
          dense
          class="mt-0 pt-0"
        />
      </div>

      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-map-marker</v-icon>
          <div class="sc-settings-list__text">
            <span class="sc-settings-list__name">Exibir UF do colaborador</span>
            <span class="sc-settings-list__desc">Mostrar a sigla do estado na tarja</span>
          </div>
        </div>
        <v-switch
          v-model="flg_exibir_uf"
          color="primary"
          hide-details
          dense
          class="mt-0 pt-0"
        />
      </div>

      <!-- Chroma color -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-palette</v-icon>
          <span class="sc-settings-list__name">Cor de background do chroma</span>
        </div>
        <v-menu
          :close-on-content-click="false"
          transition="scale-transition"
          v-model="isColorPickerOpen"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              class="action-box color-box"
              v-bind="attrs"
              v-on="on"
            >
              <div
                class="color-preview"
                :style="{ backgroundColor: chromaColorHex }"
              ></div>
              <span class="action-label">Chroma</span>
            </div>
          </template>
          <v-card class="color-picker-card">
            <v-card-text class="pa-3">
              <v-color-picker
                v-model="cor_background_chroma_tarja"
                dot-size="20"
                swatches-max-height="200"
                hide-inputs
                hide-mode-switch
                mode="hexa"
                :show-swatches="false"
              />
              <div
                class="color-preview-bar mt-3"
                :style="{ backgroundColor: chromaColorHex }"
              >
                {{ chromaColorHex }}
              </div>
              <div class="color-actions mt-3">
                <v-btn
                  outlined
                  small
                  class="reset-btn"
                  @click="resetChromaColor"
                >
                  <v-icon small left>mdi-refresh</v-icon>
                  Resetar
                </v-btn>
                <v-btn
                  color="primary"
                  small
                  class="save-btn"
                  @click="isColorPickerOpen = false"
                >
                  OK
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </div>

    <!-- Save -->
    <div class="sc-modal__footer">
      <v-btn
        color="primary"
        @click.prevent="salvarConfigTarja"
        class="modal-btn-confirm"
        :loading="loadingSave"
      >
        <v-icon small class="mr-1">mdi-check</v-icon>
        Salvar
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiClient } from "@/services/api";

export default {
  name: "ModalConfiguracaoTarja",
  props: {
    producao: Object,
  },
  data() {
    return {
      selectedTarjaPosition: null,
      tarjaPositionOptions: ["Esquerda", "Centro", "Direita"],
      dsc_telefone_producao: null,
      flg_botao_confirmar_exibicao_tarja: null,
      flg_ocultar_header_card_tarja: null,
      cor_background_chroma_tarja: null,
      flg_exibir_uf: null,
      selectedProducaoConfigCoresTarja: null,
      loadingSave: false,
      isColorPickerOpen: false,
    };
  },
  async mounted() {
    await this.getConfigTarja({
      cod_producao: this.producao.cod_producao,
    });
    await this.getProducaoConfigsCoresTarja({
      cod_producao: this.producao.cod_producao,
    });
    this.populateData();
  },
  computed: {
    ...mapGetters({
      configTarja: "tarja/getterConfigTarja",
      producaoConfigCoresTarja: "tarja/getterProducaoConfigCoresTarja",
    }),
    chromaColorHex() {
      if (!this.cor_background_chroma_tarja) return "#00FF00";
      return typeof this.cor_background_chroma_tarja === "object"
        ? this.cor_background_chroma_tarja.hex || this.cor_background_chroma_tarja.hexa
        : this.cor_background_chroma_tarja;
    },
  },
  methods: {
    ...mapActions({
      getProducaoConfigsCoresTarja: "tarja/getProducaoConfigsCoresTarja",
      getConfigTarja: "tarja/getConfigTarja",
    }),
    populateData() {
      if (!this.configTarja) return;
      this.selectedTarjaPosition =
        this.configTarja.dsc_posicao_tarja.charAt(0).toUpperCase() +
        this.configTarja.dsc_posicao_tarja.slice(1);
      this.flg_botao_confirmar_exibicao_tarja = this.configTarja.flg_botao_confirmar_exibicao;
      this.flg_ocultar_header_card_tarja = !this.configTarja.flg_display_card_header;
      this.dsc_telefone_producao = this.producao.dsc_num_telefone;
      this.cor_background_chroma_tarja = this.configTarja.dsc_hex_background_chroma;
      this.flg_exibir_uf = this.configTarja.flg_exibir_uf;
      this.selectedProducaoConfigCoresTarja =
        this.producaoConfigCoresTarja && this.configTarja.id_config_cores
          ? this.producaoConfigCoresTarja
              .filter((config) => config.id === this.configTarja.id_config_cores)
              .at(0)
          : null;
    },
    resetChromaColor() {
      this.cor_background_chroma_tarja = "#00FF00FF";
    },
    async salvarConfigTarja() {
      if (!this.selectedTarjaPosition) {
        this.$toast.info("Selecione a posição da tarja");
        return;
      }
      this.loadingSave = true;
      try {
        await apiClient.patch("/atualizarConfigTarja", {
          cod_producao: this.producao.cod_producao,
          dsc_posicao_tarja: this.selectedTarjaPosition.toLowerCase(),
          flg_botao_confirmar_exibicao: this.flg_botao_confirmar_exibicao_tarja,
          flg_display_card_header: !this.flg_ocultar_header_card_tarja,
          dsc_hex_background_chroma: this.cor_background_chroma_tarja,
          flg_exibir_uf: this.flg_exibir_uf,
          id_config_cores: this.selectedProducaoConfigCoresTarja
            ? this.selectedProducaoConfigCoresTarja.id
            : null,
        });

        await apiClient.patch("/atualizarNumeroTelefone", {
          cod_producao: this.producao.cod_producao,
          dsc_num_telefone: this.dsc_telefone_producao,
        });

        await this.getConfigTarja({
          cod_producao: this.producao.cod_producao,
        });

        if (this.producao.config_tarja_cronometro) {
          await apiClient.patch("updateCorBackgroundTarjaCronometro", {
            id_config: this.producao.config_tarja_cronometro.id,
            cod_producao: this.producao.cod_producao,
            dsc_hex_background_chroma:
              typeof this.cor_background_chroma_tarja === "object"
                ? this.cor_background_chroma_tarja.hexa
                : this.cor_background_chroma_tarja,
          });
        }

        this.$toast.success("Alterações salvas com sucesso!");
      } catch (error) {
        this.$toast.error("Erro ao salvar alterações.");
      } finally {
        this.loadingSave = false;
      }
    },
  },
  watch: {
    async producao(newVal) {
      await this.getProducaoConfigsCoresTarja({
        cod_producao: newVal.cod_producao,
      });
      await this.getConfigTarja({
        cod_producao: newVal.cod_producao,
      });
    },
    configTarja() {
      this.populateData();
    },
    producaoConfigCoresTarja() {
      this.populateData();
    },
  },
};
</script>

<style lang="scss" scoped>
/* Inputs */
.tarja-select {
  max-width: 200px;
  flex-shrink: 0;
}

.tarja-input {
  max-width: 200px;
  flex-shrink: 0;
}


.color-box {
  border-style: solid;
}

.color-preview {
  width: 28px;
  height: 28px;
  border-radius: var(--sc-radius-sm);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.color-picker-card {
  border-radius: var(--sc-radius-lg) !important;
}

.color-actions {
  display: flex;
  gap: 8px;

  .reset-btn {
    flex: 1;
    text-transform: none;
    letter-spacing: 0;
  }

  .save-btn {
    flex: 1;
    text-transform: none;
    letter-spacing: 0;
  }
}

.color-preview-bar {
  height: 32px;
  border-radius: var(--sc-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.8rem;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* Deep overrides for switches */
::v-deep .v-input--switch {
  margin: 0;
  padding: 0;
}

::v-deep .v-input--switch { margin: 0; padding: 0; }
</style>
